import { DocumentModule } from './DocumentModule';
export default DocumentModule;
